import { DEFAULT_APPEARANCE, FONT_STACKS, THEME_PRESETS } from './defaultAppearance.js';

function merge(base, override) {
  return { ...base, ...Object.fromEntries(Object.entries(override ?? {}).filter(([, v]) => v !== undefined)) };
}

/** Merges a (possibly partial) appearance config over the defaults. */
export function resolveAppearance(config) {
  const c = config ?? {};
  return {
    branding: merge(DEFAULT_APPEARANCE.branding, c.branding),
    theme: resolveTheme(c.theme),
    layout: merge(DEFAULT_APPEARANCE.layout, c.layout),
    itemDisplay: merge(DEFAULT_APPEARANCE.itemDisplay, c.itemDisplay),
  };
}

function resolveTheme(theme) {
  const presetId = theme?.preset ?? DEFAULT_APPEARANCE.theme.preset;
  const preset = THEME_PRESETS[presetId]?.theme ?? THEME_PRESETS[DEFAULT_APPEARANCE.theme.preset].theme;
  return merge({ ...DEFAULT_APPEARANCE.theme, ...preset, preset: presetId }, theme);
}

/** Appearance config -> CSS custom properties, applied to the wrapper element's `style`. */
export function appearanceToCssVariables(config) {
  const { theme } = resolveAppearance(config);
  return {
    '--rm-color-primary': theme.primaryColor,
    '--rm-color-secondary': theme.secondaryColor,
    '--rm-color-background': theme.backgroundColor,
    '--rm-color-text': theme.textColor,
    '--rm-font-family': FONT_STACKS[theme.font] ?? FONT_STACKS.system,
  };
}
